import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import { Component, Prop } from 'vue-property-decorator';
import EntityTableProvider from '@shared/components/tables/entity-table-provider/entity-table-provider.vue';
import EntityTable from '@shared/components/tables/entity-table/entity-table.vue';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import EntityDeleteModalProvider from '@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue';
import ConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';
import { ValidationObserver } from 'vee-validate';
import { mixins } from 'vue-class-component';
import AbstractTable from '@shared/components/tables/abstract-table/abstract-table';
import { ContactRelation } from '@contacts/interfaces/contact-relation';
import DrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
import StdFilter from '@shared/components/filters/std-filter/std-filter.vue';

@Component({
  name: 'bpc-contact-relation-table',
  components: {
    'bpc-entity-table-provider': EntityTableProvider,
    'bpc-entity-table': EntityTable,
    'bpc-page-title': BpcPageTitle,
    'font-awesome-icon': FontAwesomeIcon,
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bpc-confirmation-modal': ConfirmationModal,
    'bpc-std-form': StdForm,
    ValidationObserver,
    'bpc-drawer-modal': DrawerModal,
    'bpc-std-filter': StdFilter,
  },
})
export default class ContactRelationTable extends mixins(AbstractTable) {
  @Prop(String) readonly displayConfigName: string;
  @Prop(String) readonly title: string;
  @Prop(String) readonly subtitle: string;

  public entity: ContactRelation = null;
  public entityName = 'contact-relation';
  public pluralEntityName = 'contact-relations';
  public permissionEntityNameToUse = 'contacts';
  public showDrawerSettingSection: boolean = false;
  public showSettingForm: boolean = false;

  public customPageActions = {};
  public customRowActions = {};

  constructor() {
    super();
  }

  public flagsToCheckBeforeLoadEntities: Array<any> = [
    'configLoaded',
    'filtersLoaded',
    'paginationLoaded',
    'orderLoaded',
    'urlParametersLoaded',
  ];

  /* Lifecycle hooks */

  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
}
